var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.11,
    height: 66.724,
    viewBox: "0 0 81.11 66.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974",
    transform: "translate(-520.965 -511.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966",
    transform: "translate(580.594 573.296) rotate(-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M12.066,14.075h0a2.009,2.009,0,0,0,1.42-.588L23.543,3.429A2.009,2.009,0,0,0,20.7.588L12.066,9.226,3.429.588A2.009,2.009,0,0,0,.588,3.429L10.646,13.487A2.009,2.009,0,0,0,12.066,14.075Z",
    transform: "translate(0 0)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4428",
    "data-name": "Path 4428",
    d: "M0,0S9.948,38.218,70.493,42.265",
    transform: "translate(528.796 514.105) rotate(7)",
    fill: "none",
    stroke: "#58ab27",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.062a0173db61cbc95c419af6cb6dd591.svg";
export { ForwardRef as ReactComponent };